module.exports = __webpack_public_path__ + "img/change password.3eec6292.png";